function removePatternsFromCode(code, regexPatterns) {
  // Iterate over each regex pattern
  regexPatterns.forEach(pattern => {
      // Replace the matched pattern with an empty string
      code = code.replace(pattern, '');
  });
  return code;
}

export default removePatternsFromCode